import React from "react";

import Section from "../shared/section";
import BlogCard from "./blog-card";
import Project1 from "../../images/e-commerceApp1.jpg";
import Project2 from "../../images/youtube1.png";
import Project3 from "../../images/movie.jpg";

import "./style.scss";

const Blogs = () => {
    return (
        <Section
            id="projects"
            title="PROJECTS"
            background="dark"
        >
            <div className="blogs-content-wrapper">
                <BlogCard
                    image={Project1}
                    title="E-Commerce App"
                    description="React, Redux, Node, Express, MongoDB, JWT-Auth, Stripe"
                    link="https://github.com/sandesh300/react-ecommerce"
                />
                <BlogCard
                    image={Project2}
                    title="YouTube Clone App"
                    description="Java, SpringBoot, MongoDB, Angular, Auth0, JWT-Auth, Spring-MVC"
                    link="https://github.com/sandesh300/YouTube-Clone"
                />
                <BlogCard
                    image={Project3}
                    title="Movie App"
                    description="Java, Spring Boot, MySQL, React, Spring-MVC, Maven"
                    link="https://github.com/sandesh300/Movie-App"
                />
              
            </div>
        </Section>
    );
};

export default Blogs;
